import script from "./DashboardMeetingsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardMeetingsWidget.vue?vue&type=script&setup=true&lang=js"

import "./DashboardMeetingsWidget.vue?vue&type=style&index=0&id=634f305e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634f305e"]])

export default __exports__